enum IncentiveProgramRoutes {
  List = '/content-settings/incentive-program',
  Add = '/content-settings/incentive-program/add',
  Edit = '/content-settings/incentive-program/:id',
}

export default IncentiveProgramRoutes
